/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Registry_WebnicInputs */

const id_tld_pricing_registry_webnic = /** @type {(inputs: Tld_Pricing_Registry_WebnicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webnic`)
};

const en_tld_pricing_registry_webnic = /** @type {(inputs: Tld_Pricing_Registry_WebnicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webnic`)
};

/**
* | output |
* | --- |
* | "Webnic" |
*
* @param {Tld_Pricing_Registry_WebnicInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_registry_webnic = /** @type {((inputs?: Tld_Pricing_Registry_WebnicInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Registry_WebnicInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_registry_webnic(inputs)
	return id_tld_pricing_registry_webnic(inputs)
});